import { Button, Col, Form, Input, message, Modal, Row, Space, TimePicker } from "antd"
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import Presets from "../../../extensions/presets";
import { daysOfWeek } from "../../../extensions/helper";
import { fmtTime, cnvString2Time } from "../../../extensions/utils";

const Calendar = ({ id, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [item, setItem] = useState({name: ""});

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`calendar/${id}`)
        .then(data => {
          // days => start/finish
          data.days.forEach(i => {
            i.start && (data[`start${i.dayId}`] = cnvString2Time(i.start));
            i.finish && (data[`finish${i.dayId}`] = cnvString2Time(i.finish));
          });
          setLoading(false);
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
    }
  }

  useEffect(getData, [id]);

  const onSave = () => {
    const data = {...item, days: []};
    // start/finish => days
    daysOfWeek.forEach(i => {
      if (data[`start${i.value}`] && data[`finish${i.value}`])
        data.days.push({dayId: i.value, start: fmtTime(data[`start${i.value}`]), finish: fmtTime(data[`finish${i.value}`])})
    })
    setLoading(true);
    serverFetch("calendar", {method: id ? "PUT" : "POST", bodyData: data})
      .then(i => onClose(i.id))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
    // onClose(true);
  }

  const onValuesChange = (value) => {
    setItem({ ...item, ...value });
  };

  const formItems = daysOfWeek.map(i => <Form.Item label={i.label} key={i.value}>
    <Row>
      <Col span={10}><Form.Item name={`start${i.value}`}><TimePicker format="HH:mm" /></Form.Item></Col>
      <Col span={2}><Form.Item>-</Form.Item></Col>
      <Col span={10}><Form.Item name={`finish${i.value}`}><TimePicker format="HH:mm" /></Form.Item></Col>
    </Row>
  </Form.Item>)

  return<Modal {...Presets.modalInfo} onCancel={() => onClose(false)} onOk={onSave} title="Календарь">
    <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading} onValuesChange={onValuesChange}>
      <Form.Item label="Наименование" name="name"><Input maxLength={80}/></Form.Item>
      {formItems}
      <Form.Item label=" "><Space>
        <Button onClick={onSave}>Сохранить</Button>
        <Button onClick={() => onClose(false)}>Закрыть</Button>
      </Space></Form.Item>
    </Form>
  </Modal>
}

export default Calendar;